<template>
  <div class="form-card">
    <div class="form-card__header">
      <div class="form-card__header-icon"><i class="pi pi-money-bill"></i></div>
      <div>
        <p class="form-card__title">الأسعار والخطط</p>
        <p class="form-card__subtitle">اترك الحقل فارغاً لتعطيل تلك الخطة</p>
      </div>
    </div>
    <div class="form-card__body">
      <div class="ds-field-grid ds-field-grid--4">
        <div class="form-field">
          <label class="field-label">سعر الشهر</label>
          <input type="number" class="form-control" v-model="form.monthly_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">سعر الترم الأول</label>
          <input type="number" class="form-control" v-model="form.term1_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">سعر الترم الثاني</label>
          <input type="number" class="form-control" v-model="form.term2_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">السعر السنوي</label>
          <input type="number" class="form-control" v-model="form.yearly_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">نهاية الترم الأول <span class="optional">اختياري</span></label>
          <input type="date" class="form-control" v-model="form.term1_end_date" />
        </div>
        <div class="form-field">
          <label class="field-label">نهاية الترم الثاني <span class="optional">اختياري</span></label>
          <input type="date" class="form-control" v-model="form.term2_end_date" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Shared "Pricing" product-editor section (Courses / Academic Years). `form` is the
// parent's reactive form object passed by reference — mutating its fields here stays
// in sync with the parent without emit boilerplate (same convention as the rest of
// this admin panel's form components).
export default {
  name: 'ProductPricingSection',
  props: {
    form: { type: Object, required: true },
  },
};
</script>
